/* The one translation bundle shared by app and web (flat dotted keys, sorted). Each language is a
   lazy chunk, so a consumer only ships the language it actually activates. */
export type TranslationLanguage = 'de' | 'en';

const TRANSLATION_BUNDLES: Record<TranslationLanguage, () => Promise<{ default: Record<string, unknown> }>> = {
  de: () => import('./de.json'),
  en: () => import('./en.json')
};

/** Language codes are case-insensitive: the web passes `DE`, the app `de`. An unsupported code
    (the app forwards the raw device language) rejects, which Transloco handles like a failed fetch. */
export function loadTranslation(lang: string): Promise<Record<string, unknown>> {
  const load = TRANSLATION_BUNDLES[lang.toLowerCase() as TranslationLanguage];
  if (!load) {
    return Promise.reject(new Error(`Unsupported translation language "${lang}"`));
  }
  return load().then((bundle) => bundle.default);
}
